/**
 * GLORY PRICE CONVERTER
 * Konvertuje sve cene na sajtu iz RSD u KM za BiH posetioce.
 * Zaokružuje na najbliži ceo broj (99.96 KM → 100 KM).
 *
 * Zahteva window.GLORY objekat iz glory-geo.liquid snippet-a.
 */

(function() {
  'use strict';

  // Ako GLORY objekat ne postoji ili nije BiH, ne radi ništa
  if (!window.GLORY || !window.GLORY.isBiH) {
    return;
  }

  var KURS = window.GLORY.rsdToKm || 0.01666;

  // ========== SELEKTORI CENA ==========
  // Shopify standard + custom Glory klase iz teme
  var PRICE_SELECTORS = [
    '.money',                              // Shopify standard
    '.price-item',                         // Dawn standard

    // Cart drawer
    '.glory-cart-item__price',
    '.glory-cart-item__price-compare',
    '.glory-cart-drawer__totals-value',
    '.glory-cart-drawer__subtotal-value',
    '.glory-cart-suggestion__price',
    '.glory-shipping-protection__price',
    '.glory-cart-drawer__discount span',

    // Cart page (glavna /cart stranica)
    '.glory-cart-page__total-value',
    '.glory-cart-page__item-price',
    '.glory-cart-page__item-price-compare',
    '.glory-cart-page__item-total',

    // Product cards — collection (price + price-compare)
    '.glory-product-card__price',
    '.glory-product-card__price-compare',
    '.glory-product-card__price--sale',

    // Product cards — bestsellers (price-current + price-old)
    '.glory-product-card__price-current',
    '.glory-product-card__price-old',

    // Product page (hero cena)
    '.glory-product-hero__price',
    '.glory-product-hero__compare',
    '.glory-product__price',
    '.glory-product__price-compare',
    '.glory-product__price-current',
    '.glory-product__price-old',

    // Product page — related/slične kompozicije
    '.glory-product__related-price',

    // Shipping progress amount
    '.glory-cart-drawer__shipping-text strong',

    // Generic hook
    '[data-glory-price]'
  ].join(', ');

  // ========== REGEX ZA PARSIRANJE CENA ==========
  // Hvata cene tipa "6,000.00 RSD", "6.000,00 РСД", "РСД6,000.00", "6000 RSD"
  // i slične varijacije sa različitim separatorima hiljada/decimala
  var PRICE_REGEX = /(?:РСД|RSD|дин\.?|Дин\.?|din\.?)\s*([\d.,]+)|([\d.,]+)\s*(?:РСД|RSD|дин\.?|Дин\.?|din\.?)/gi;

  // ========== HELPER FUNKCIJE ==========

  /**
   * Parsira string "6.000,00" ili "6,000.00" u broj 6000.
   * Shopify koristi različite formate zavisno od lokalizacije.
   */
  function parseRsdNumber(str) {
    if (!str) return 0;
    str = String(str).trim();

    // Ukloni sve non-numeric karaktere osim , i .
    var clean = str.replace(/[^\d.,]/g, '');

    // Odredi decimalni separator
    // Ako ima oba . i , — poslednji je decimalni
    var lastDot = clean.lastIndexOf('.');
    var lastComma = clean.lastIndexOf(',');

    if (lastDot > -1 && lastComma > -1) {
      // Oba su prisutna — poslednji je decimalni
      if (lastDot > lastComma) {
        // Format: 6,000.00 (engleski)
        clean = clean.replace(/,/g, '');
      } else {
        // Format: 6.000,00 (evropski)
        clean = clean.replace(/\./g, '').replace(',', '.');
      }
    } else if (lastComma > -1) {
      // Samo zarez — može biti decimalni (99,96) ili separator hiljada (6,000)
      // Ako je samo 2 cifre posle zareza → decimalni
      var afterComma = clean.length - lastComma - 1;
      if (afterComma === 2 || afterComma === 1) {
        clean = clean.replace(',', '.');
      } else {
        clean = clean.replace(/,/g, '');
      }
    }
    // Ako ima samo tačku, pretpostavi da je to valjan broj (tačka kao decimalni)

    return parseFloat(clean) || 0;
  }

  /**
   * Konvertuje RSD u KM i vraća formatiran string.
   * Zaokružuje na ceo broj (99.96 KM → 100 KM).
   */
  function formatKM(rsdAmount) {
    var km = rsdAmount * KURS;
    var rounded = Math.round(km);
    return rounded + ' KM';
  }

  /**
   * Zameni cene u tekstu.
   * Nađe sve pojave RSD iznosa i zameni sa KM.
   */
  function convertTextContent(text) {
    if (!text || typeof text !== 'string') return text;

    var hasRsdCurrency = /РСД|RSD|дин\.?|Дин\.?|din\.?/i.test(text);
    if (!hasRsdCurrency) {
      // Nema currency markera — možda je čist broj u price elementu
      // U tom slučaju pretpostavi da je RSD (jer smo u price selektoru)
      var numMatch = text.match(/^\s*([\d.,]+)\s*$/);
      if (numMatch) {
        var rsd = parseRsdNumber(numMatch[1]);
        if (rsd > 0) {
          return text.replace(numMatch[1], function() {
            return formatKM(rsd).replace(' KM', '');
          }) + ' KM';
        }
      }
      return text;
    }

    // Ima currency marker — zameni komplikovanijim regexom
    return text.replace(PRICE_REGEX, function(match, num1, num2) {
      var numStr = num1 || num2;
      var rsd = parseRsdNumber(numStr);
      if (rsd <= 0) return match;
      return formatKM(rsd);
    });
  }

  /**
   * Konvertuje ceo element — i tekst i data atribute.
   * Koristi data-glory-converted da pamti da je već obrađen
   * (da se ne konvertuje više puta).
   *
   * VAŽNO: preskače elemente koji imaju child elemente u price selektorima —
   * to su wrapperi (npr. .glory-product-card__price u bestsellers), i mi želimo
   * da obradimo same children (price-old, price-current), ne wrapper.
   */
  function convertElement(el) {
    if (!el || el.dataset.gloryConverted === '1') return;

    // Ako ovaj element sadrži druge price elemente kao children → preskoči ga,
    // pustimo da se children obrade direktno (oni imaju svoj tekst)
    if (el.querySelector(PRICE_SELECTORS)) {
      el.dataset.gloryConverted = '1';
      return;
    }

    var original = el.textContent;
    var converted = convertTextContent(original);

    if (converted !== original) {
      el.dataset.gloryOriginalText = original;
      el.textContent = converted;
      el.dataset.gloryConverted = '1';
    } else {
      // Element nema RSD currency marker i nije valjan broj — označi kao obrađen
      el.dataset.gloryConverted = '1';
    }
  }

  /**
   * Prolazi kroz sve price elemente na stranici i konvertuje ih.
   */
  function convertAllPrices(root) {
    root = root || document;
    var elements = root.querySelectorAll(PRICE_SELECTORS);
    for (var i = 0; i < elements.length; i++) {
      convertElement(elements[i]);
    }
  }

  // ========== ANTI-FLICKER STRATEGIJA ==========
  // Dodaj CSS koji sakriva cene dok ne budu konvertovane.
  // Cene se pojavljuju čim dobiju klasu .glory-km-converted na parent-u
  // ili data-glory-converted atribut.

  var styleEl = document.createElement('style');
  styleEl.textContent = [
    '/* Glory Price Converter — anti-flicker */',
    'body:not(.glory-prices-ready) ' + PRICE_SELECTORS.split(', ').join(', body:not(.glory-prices-ready) ') + ' {',
    '  visibility: hidden !important;',
    '}',
    '/* Fail-safe: posle 2s uvek prikaži cene */',
    '.glory-prices-ready ' + PRICE_SELECTORS.split(', ').join(', .glory-prices-ready ') + ' {',
    '  visibility: visible !important;',
    '}'
  ].join('\n');
  (document.head || document.documentElement).appendChild(styleEl);

  // ========== POKRETANJE ==========

  function init() {
    convertAllPrices();
    document.body.classList.add('glory-prices-ready');

    // MutationObserver — prati nove elemente (cart drawer refresh, AJAX load, itd.)
    var observer = new MutationObserver(function(mutations) {
      var shouldConvert = false;
      for (var i = 0; i < mutations.length; i++) {
        var mut = mutations[i];
        if (mut.addedNodes && mut.addedNodes.length > 0) {
          shouldConvert = true;
          break;
        }
      }
      if (shouldConvert) {
        // Debounce — prikupi sve izmene u 50ms pa jednom obradi
        if (observer._timer) clearTimeout(observer._timer);
        observer._timer = setTimeout(function() {
          convertAllPrices();
        }, 50);
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  // Pokreni odmah ako je DOM spreman, ili sačekaj
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Fail-safe: uvek prikaži cene posle 2s čak i ako init nije pozvan
  setTimeout(function() {
    if (document.body && !document.body.classList.contains('glory-prices-ready')) {
      document.body.classList.add('glory-prices-ready');
    }
  }, 2000);

  // Expose API za debugging i manuelne pozive
  window.GLORY.convertPrices = convertAllPrices;
  window.GLORY.convertElement = convertElement;
})();